<app-header></app-header>
<app-search-flights></app-search-flights>
<app-deals></app-deals>
<app-footer></app-footer>